import { render, staticRenderFns } from "./movimientosCajas.vue?vue&type=template&id=3492bbc3&scoped=true"
import script from "./movimientosCajas.vue?vue&type=script&lang=js"
export * from "./movimientosCajas.vue?vue&type=script&lang=js"
import style0 from "./movimientosCajas.vue?vue&type=style&index=0&id=3492bbc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3492bbc3",
  null
  
)

export default component.exports